import resellersModule from "../resellersModule.js";
import { NumberFormatting } from "Roblox";
import { Endpoints } from "Roblox";
import { CurrentUser } from "Roblox";

function resellersListController(resellersConstants, languageResource, thumbnailConstants, resaleService, systemFeedbackService) {
    "ngInject";
    var ctrl = this;

    ctrl.formatNumber = function (number) {
        if (number > 0) {
            return NumberFormatting.commas(number);
        }

        return languageResource.get(resellersConstants.translationKeys.notAvailable);
    };

    ctrl.takeOffSale = function (resaleRecord) {
        ctrl.takeOffSaleDebounce[resaleRecord.userAssetId] = true;

        resaleService.takeOffSale(ctrl.assetData.id, resaleRecord.userAssetId).then(function () {
            delete ctrl.takeOffSaleDebounce[resaleRecord.userAssetId];

            // Successfully taken off sale, remove it from the list.
            var resaleIndex = ctrl.resaleRecords.indexOf(resaleRecord);
            ctrl.resaleRecords.splice(resaleIndex, 1);
        }).catch(function () {
            delete ctrl.takeOffSaleDebounce[resaleRecord.userAssetId];

            systemFeedbackService.warning(languageResource.get(resellersConstants.translationKeys.takeOffSaleFailure), 0, resellersConstants.errorBannerTimeout);
        });
    };

    ctrl.getProfilePageUrl = function (userId) {
        return Endpoints.getAbsoluteUrl(`/users/${userId}/profile`);
    };

    const init = function () {
        ctrl.takeOffSaleDebounce = {};
        ctrl.thumbnailTypes = thumbnailConstants.thumbnailTypes;
        ctrl.authenticatedUser = {
            id: Number(CurrentUser.userId)
        };
    };

    ctrl.$onInit = init;
}

resellersModule.controller("resellersListController", resellersListController);
export default resellersListController;